module.exports = __webpack_public_path__ + "img/contigreen.8d1d2854.jpg";